import React, { useRef, useEffect } from 'react';
import './FloorPlanVideo.css'; // Import your CSS file

const FloorPlanVideo = ({ videoSrc }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.load(); // Load the video
    }
  }, [videoSrc]);

  return (
    <div className="floorplan-video-container">
      <video ref={videoRef} className="floorplan-video" controls muted loop>
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default FloorPlanVideo;